import { ApprovalStatus } from 'enums';
import { getApprovalStatusLabel } from 'enums/type-mappers/approval-status-config';
import { FilterElementProps } from 'utils';
import { HotjarEvents } from 'utils/hotjar-events';
import useSubmissionFilter from 'broker/components/SubmissionsView/useSubmissionFilter';
import { queueStorageKeys } from './config';

const baseApprovalStatusFiltersList: FilterElementProps[] = Object.values(ApprovalStatus).map((status) => ({
  key: status,
  checked: false,
  label: getApprovalStatusLabel(status),
}));

interface UseApprovalStatusFilterProps {
  paginationReset: () => void;
}

export function useApprovalStatusFilter({ paginationReset }: UseApprovalStatusFilterProps) {
  return useSubmissionFilter({
    baseFiltersList: baseApprovalStatusFiltersList,
    storageKey: queueStorageKeys.approvalStatus,
    hotjarEvent: HotjarEvents.SubmissionsStatusFilter,
    paginationReset,
  });
}
